import { ThemeEvents } from "@theme/events";

class PromoQuantityHint extends HTMLElement {
  #abortController = null;
  #cartQty = 0;

  connectedCallback() {
    // The theme morphs sections (variant changes, initial render), which
    // disconnects and reconnects this element. A fresh controller per connect
    // is required — an aborted signal would turn re-added listeners into no-ops.
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    const section = this.closest(".shopify-section");

    section?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#handleQuantityChange, { signal });
    section?.addEventListener("change", this.#handleQuantityChange, { signal });
    // After a variant change the section is morphed and the quantity input is
    // re-rendered with its default value without firing a change event.
    section?.addEventListener(ThemeEvents.variantUpdate, this.#handleQuantityChange, { signal });
    document.addEventListener(ThemeEvents.cartUpdate, this.#refreshCartQuantity, { signal });

    this.#refreshCartQuantity();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  get #selectorQuantity() {
    const section = this.closest(".shopify-section");
    const input = section?.querySelector('product-form-component form input[name="quantity"]');
    return Number(input?.value) || 0;
  }

  #handleQuantityChange = () => {
    // Wait a tick so a morph triggered by the same event has updated the input.
    // setTimeout instead of requestAnimationFrame: rAF stalls in hidden tabs.
    setTimeout(() => this.#render(), 0);
  };

  #refreshCartQuantity = () => {
    fetch(window.FoxTheme.routes.cart)
      .then((response) => response.json())
      .then((cart) => {
        const productId = Number(this.dataset.productId);
        this.#cartQty = cart.items
          .filter((item) => item.product_id === productId)
          .reduce((sum, item) => sum + item.quantity, 0);
        this.#render();
      })
      .catch(() => {});
  };

  #render() {
    const targetQty = Number(this.dataset.targetQty) || 2;
    const reached = this.#cartQty >= targetQty || this.#cartQty + this.#selectorQuantity >= targetQty;

    const defaultHint = this.querySelector('[ref="promoHintDefault"]');
    const successHint = this.querySelector('[ref="promoHintSuccess"]');
    if (defaultHint) defaultHint.style.display = reached ? "none" : "flex";
    if (successHint) successHint.style.display = reached ? "flex" : "none";
  }
}

if (!customElements.get("promo-quantity-hint")) {
  customElements.define("promo-quantity-hint", PromoQuantityHint);
}
